/* eslint-disable @typescript-eslint/no-unused-vars */
import { Action, PayloadAction } from '@reduxjs/toolkit';
import { Epic, StateObservable, ofType } from 'redux-observable';
import { Observable, catchError, concatMap, from, of } from 'rxjs';

import { Dependencies } from '@configurations/dependencies/dependencies';
import { RootState } from '@store/create-store';
import {
  retrieveFilteredReferentialsBasecaseIdsSuccess,
  retrieveFilteredReferentialsIdsFailure,
  retrieveFilteredReferentialsMarketAreaIdsSuccess,
  retrieveFilteredReferentialsSourceIdsSuccess,
  retrieveFilteredReferentialsSubtypeIdsSuccess,
  retrieveFilteredReferentialsWeatherYearIdsSuccess,
  retrieveFilteredReferentialsZoneIdsSuccess,
} from '@store/scenario/filtered-referentials/filtered-referentials-ids-slice';
import { FilteredReferentialsIds } from '@scenario/models/filtered-referentials-ids.model';
import { Filters } from '@scenario/enums/filters.enum';

export const retrieveFilteredReferentialsIdsEpic: Epic<Action, Action, RootState, Dependencies> = (
  action$: Observable<Action>,
  _state$: StateObservable<RootState>,
  dependencies: Dependencies,
) =>
  action$.pipe(
    ofType('filteredReferentialsIds/retrieveFilteredReferentialsIds'),
    concatMap((action: PayloadAction<{inactiveFields: (keyof FilteredReferentialsIds)[], filteredReferentialsIds: FilteredReferentialsIds}>) =>
      from(dependencies.filteredReferentialsIdsGateway.retrieveAllIds(action.payload.filteredReferentialsIds)).pipe(
        concatMap((filteredReferentialsIds: FilteredReferentialsIds) =>
          from(action.payload.inactiveFields.flatMap((field: keyof FilteredReferentialsIds) => {
            const lowerField = field.toLocaleLowerCase();

            if (lowerField.includes(Filters.REGION.toLocaleLowerCase())) {
              return retrieveFilteredReferentialsZoneIdsSuccess(filteredReferentialsIds.zoneIds);
            }
            if (lowerField.includes(Filters.SOURCE.toLocaleLowerCase())) {
              return retrieveFilteredReferentialsSourceIdsSuccess(filteredReferentialsIds.sourceIds);
            }
            if (lowerField.includes(Filters.BASECASE.toLocaleLowerCase())) {
              return retrieveFilteredReferentialsBasecaseIdsSuccess(filteredReferentialsIds.basecaseIds);
            }
            if (lowerField.includes(Filters.SUBTYPE.toLocaleLowerCase())) {
              return retrieveFilteredReferentialsSubtypeIdsSuccess(filteredReferentialsIds.subtypeIds);
            }
            if (lowerField.includes(Filters.WEATHER_YEAR.toLocaleLowerCase().split('_')[0])) {
              return retrieveFilteredReferentialsWeatherYearIdsSuccess(filteredReferentialsIds.weatherYearIds);
            }
            if (lowerField.includes(Filters.MARKET_AREA.toLocaleLowerCase().split('_')[0])) {
              return retrieveFilteredReferentialsMarketAreaIdsSuccess(filteredReferentialsIds.marketAreaIds);
            }
            return [];
          }))
        ),
        catchError(() => of(retrieveFilteredReferentialsIdsFailure('Fail to retrieve filtered referentials ids'))),
      ),
    ),
  );
